// 路由导航守卫
import router from '@/router/index'
import {
  checkMobile,
  environmentJudge,
  QYWX,
  DINGTALK,
  APP,
  FEISHU,
  YKY
} from '@/utils/utils.js'
import { getUserInfo } from '@/api/login/login'
import { useUserStore, useDeviceStore } from '@/store/home'
import { deviceWhiteLists, deviceWhiteList } from '@/utils/pageManage.js'
import dd from 'dingtalk-jsapi'
import NoSleep from 'nosleep.js'
import { dingTalkNavigation } from '@/utils/dingTalkNavigation.js'
import { useGlobal } from '@/store/global'
import { Toast } from 'vant'
import { xda } from '@hybird/flutter'
import { Device } from '@hybird/device'
import { yyApi } from '@/utils/keyMap'
// 白名单
const whiteList = [
  '/login',
  '/loginAccount',
  '/forgotPwd',
  '/download',
  '/loginPC',
  '/privacyPolicy',
  '/stampCode',
  '/ykyAbout',
  '/ykyWifiSetting',
  '/ykySetting',
  '/ykyFingerprint'
] // 无需登陆的页面

// 守卫
router.beforeEach(async (to, from, next) => {

  // 康宁TODO
  if (to.href.includes('h5/h5')) {
    const path = to.fullPath.replace('/h5', '')
    next(path)
    return
  }
  console.log(to, from)

  const userStore = useUserStore()
  const deviceStore = useDeviceStore()
  const globalStore = useGlobal()
  const noSleep = new NoSleep()
  console.log('to.ptth', to.path)
  !localStorage.getItem('userInfo') && localStorage.removeItem('sessionId')
  // next();
  const environment = environmentJudge()
  if (
    to.path === '/loginAccount' &&
    [APP, YKY].includes(environment) &&
    localStorage.getItem('sessionId')
  ) {
    next({
      path: '/home',
      replace: true
    })
  }
  // 获取本地token
  const { sessionId, enterpriseId } = getIDsAfterCheck(to.query.enterpriseId)
  const corpId = to.query.corpId || localStorage.getItem('corpId')
  const appId = to.query.appId || localStorage.getItem('appId')
  const mobile = localStorage.getItem('mobile')
  const isMobile = checkMobile()
  enterpriseId && localStorage.setItem('enterpriseId', enterpriseId)
  corpId && localStorage.setItem('corpId', corpId)
  appId && localStorage.setItem('appId', appId)
  console.log('看一看appId', to.query)

  const businessType = to.query.businessType
  const userAgent = navigator.userAgent
  const isPcDingTalk =
    /DingTalk/i.test(userAgent) &&
    (/Windows/i.test(userAgent) || /Macintosh/i.test(userAgent))
  console.log('去的页面', to, userAgent)
  const urlHeader = `dingtalk://dingtalkclient/action/openapp?corpid=${corpId}&container_type=work_platform&app_id=appId&redirect_type=jump&redirect_url=`
  let toUrl
  if (isPcDingTalk && sessionId && !whiteList.includes(to.path)) {
    toUrl = await dingTalkNavigation(to)
    console.log('跳转到的pc页面', toUrl)
    if (toUrl && !process.env.newConnect) {
      dd.biz.util.openLink({
        url: `${urlHeader}${encodeURIComponent(
                `${import.meta.env.VITE_PC_URL == '/' ? window.location.origin : import.meta.env.VITE_PC_URL}${toUrl}&sessionId=${sessionId}&enterpriseId=${enterpriseId}`
        )}`
        // 要打开链接的地址
      })
      window.close()
      dd.biz.navigation.quit()
    }
  }
  if (businessType) {
    localStorage.setItem('message_url', window.location.href)
  }
  // 人工审批版本 记录详情 合并为 用印详情 所以拦一手
  if (to.path == '/recordDetail') {
    next({
      path: '/applyDetail',
      query: {
        id: to.query.documentId ?? '',
        ...to.query
      },
      replace: true
    })
  }
  if (to.path === '/approveDetails') {
    if (Object.keys(to.query).includes('tabType')) {
      if (to.query['tabType'] == 1) {
        to.meta.title = '申请详情'
      }
    }
  }

  // 处理钉钉iOS查看附件，返回时页面变大
  const hasFilePages = [
    '/applyDetail',
    '/approveDetails',
    '/informDetail',
    '/exportPdf'
  ]
  console.log(
    'to.path',
    to.path,
    'from.path',
    from.path,
    'sessionId',
    sessionId,
    hasFilePages.includes(to.path)
  )
  if (to.path == from.path && sessionId && hasFilePages.includes(to.path)) {
    if (!globalStore.isNotReload) {
      window.location.reload()
    }
  }

  //处理用印页面replace页面重复问题
  if (to.path == from.path && globalStore.isNotReload) {
    console.log('to.pat---', to.path == from.path)
    //--
    const fromPageSource = from.query.pageSource
    const toPageSource = to.query.pageSource
    const isPageSourceChanged = fromPageSource && toPageSource && String(fromPageSource) !== String(toPageSource)
    if (isPageSourceChanged) return next();
    //新加条件 解决applyDetail pagesource1 跳转到  applyDetail pagesource2的问题
    window.history.go(-1)
    return next()
  }
  // if (sessionId &&hasFilePages.includes(to.path) &&hasFilePages.includes(from.path)) {
  //   window.location.reload()
  // }

  // 除去设备可连接相关页面外，如果设备连接则退出登录
  // 连接设备之后页面刷新处理
  const deviceProtocol = Device.getByNumber(
    deviceStore.connectDeviceNumber
  )?.deviceProtocol

  // if (deviceWhiteLists.includes(to.path) && !deviceStore.isConnect) {
  if (deviceWhiteLists.includes(to.path) && !deviceProtocol?.connected) {
    let id
      // 申请详情id处理
      ; (to.query.documentId || to.query.documentRemoteId) &&
        (id = to.query.documentId || to.query.documentRemoteId)
    next({
      path: to.query.from,
      query: {
        number: to.query.number,
        id,
        documentId: to.query.documentId,
        // 加个业务单据编码
        processInstanceId: to.query.processInstanceId,
        sealType: 1,
        modelType: to.query.modelType
      },
      replace: true
    })
  }

  // 断开连接处理
  if (!deviceWhiteList.includes(to.path)) {
    deviceStore.isConnect = false
    const deviceProtocol = Device.getByNumber(
      deviceStore.connectDeviceNumber
    )?.deviceProtocol

    deviceStore.isConnect = false
    if (deviceProtocol && deviceProtocol.connected) {
      await deviceProtocol?.disconnect()
      deviceStore.restConnectInfo()
    }
    // 如果 存储了用印管理tab状态 并且要去的页面不需要保持连接 即不是需要用印的页面 就不需要tab缓存了
    if (localStorage.getItem('sealManageTab') == 2) {
      localStorage.removeItem('sealManageTab')
    }
  } else {

    if (
      [
        '/waitUse',
        '/applyDetail',
        '/applyList',
        '/recordDetail',
        '/exportPdf',
        "/padUseSeal",
      ].includes(to.path) &&
      deviceStore.isConnect
    ) {
      yyApi.rmDocumentLoginId()
      const isNew = deviceStore.isNewSeal()
      //新版本固件逻辑（老版本固件照常断开）
      if (isNew) {
        //用印管理与系统通知进入的申请详情正常断开连接（只待用印进入的申请详情不断开）
        if (
          ['/applyDetail', '/recordDetail', '/exportPdf'].includes(to.path) &&
          from.path !== '/waitUse' &&
          !to.query.notDisConnect
        ) {
          deviceStore.deviceLogout()
        } else {
          //退到申请详情｜待用印列表并处于连接状态就退出盖印模式
          deviceStore.cancelSealMode()
        }
      } else {
        deviceStore.deviceLogout()
      }
    }
  }

  if (to.path == '/download') {
    next()
  }
  // 不在判断范畴 = 浏览器环境
  console.log('import.meta.env.MODE', import.meta.env.MODE, environment)
  if (environment == 'OTHERS' && import.meta.env.MODE !== 'development' && !process.env.newConnect) {
    // if (environment == 'OTHERS' && import.meta.env.MODE !== 'uat') {
    console.log('import.meta.env.MODE', import.meta.env.MODE)
    if (isMobile) {
      next({
        path: '/download',
        replace: true
      })
    } else {
      if (!process.env.newConnect)
        window.location.href = import.meta.env.VITE_PC_URL == '/' ? window.location.origin : import.meta.env.VITE_PC_URL
    }
    return
  }

  // 在钉钉pc并且消息推送，没有sessionid
  if (
    businessType &&
    environment == DINGTALK &&
    !sessionId &&
    !whiteList.includes(to.path)
  ) {
    // console.log('触发了钉钉的特殊', window.location.href)
    next({
      path: `/login`,
      query: {
        enterpriseId,
        businessType
      },
      replace: true
    })
    return
  }

  // 由PC项目中登录出现问题跳回来的情况
  if (to.query.isFailPC) {
    localStorage.removeItem('userInfo')
    localStorage.removeItem('sessionId')
    next({
      path: `/loginPC`,
      query: { enterpriseId },
      replace: true
    })
    return
  }
  const kangningUserToken = to.query.userToken || localStorage.getItem('isKANGNING') || null
  if (!sessionId && !whiteList.includes(to.path)) {
    console.log(898787889, environment)
    if (environment == APP || environment == YKY || environment == 'OTHERS') {
      next({ path: '/loginAccount', replace: true })
    } else {
      if (isMobile) {
        next({
          path: `/login`,
          query: { enterpriseId, userToken: kangningUserToken },
          replace: true
        })
      } else {
        next({
          path: `/loginPC`,
          query: { enterpriseId,userToken: kangningUserToken },
          replace: true
        })
      }
    }
  } else {
    // PC端自动登录（有sessionId）
    if (environment != 'OTHERS' && !isMobile && sessionId) {
      const businessType = to.query.businessType
      const isPush = to.query.isPush
      const processMold = to.query.processMold ?? 1
      if ((isPush || businessType) && environment == DINGTALK) {
        next()
        return
      }

      let toPath = await dingTalkNavigation(to)

      if (!process.env.newConnect) {
        if (toPath && businessType) {
          window.location.href = `${import.meta.env.VITE_PC_URL == '/' ? window.location.origin : import.meta.env.VITE_PC_URL}${toPath}&sessionId=${sessionId}&enterpriseId=${enterpriseId}`
        } else {
          window.location.href = `${import.meta.env.VITE_PC_URL == '/' ? window.location.origin : import.meta.env.VITE_PC_URL}?sessionId=${sessionId}&enterpriseId=${enterpriseId}`
        }
      }
      next()
      return
    }
    // 企业微信没有手机号跳转绑定页面
    if (
      environment == QYWX &&
      !mobile &&
      !whiteList.includes(to.path) &&
      to.path != '/phone'
    ) {
      next({
        path: '/phone',
        query: { enterpriseId },
        replace: true
      })
      return
    }
    document.title = to.meta.title || '玺得安'
    // console.log('document.title', document.title)
    // eslint-disable-next-line no-undef
    if (environment == DINGTALK) {
      dd.biz.navigation.setTitle({ title: document.title })
    }
    if (environment === QYWX || environment == FEISHU) {
      const button = document.createElement('button')
      button.addEventListener('click', () => {
        noSleep.enable()
      })
      button.style.display = 'none'
      document.body.appendChild(button)
      button.click()
    }
    const currentStaffID = localStorage.getItem('currentStaffID')

    if (!currentStaffID && sessionId) {
      const { data } = await getUserInfo()
      localStorage.setItem('currentStaffID', data.result.staffId)
      localStorage.setItem('userInfo', JSON.stringify(data))
      userStore.userInfo = data.result
    }
    // 给所有路径加上enterpriseId
    if (to.query.enterpriseId || whiteList.includes(to.path)) {
      // 钉钉PC推送
      if (from.query.isPush && !to.query.isPush) {
        next({
          path: to.path,
          query: { ...to.query, isPush: 1 }
        })
      } else {
        next()
      }
    } else {
      to.query = { ...to.query, enterpriseId }
      next()
      // next({
      //   path: to.path,
      //   query: { ...to.query, enterpriseId }
      //   // replace: true
      // })
    }
  }
})

function getIDsAfterCheck(newID) {
  const oldID = localStorage.getItem('enterpriseId')
  // console.log(oldID != newID, '---------------企业id比较', oldID, newID)
  if (oldID && newID && oldID != newID) {
    localStorage.removeItem('sessionId')
    localStorage.removeItem('userInfo')
  }
  return {
    sessionId: localStorage.getItem('sessionId'),
    enterpriseId: newID || oldID
  }
}

/*
 修复 钉钉ios 在项目点开附件 window.open 打开附件地址时  
 会通过内嵌浏览器钉钉内打开，返回到项目时 字体变大导致屏幕不适配的问题
 */
const originFontSize = document.documentElement.style.fontSize
window.onpageshow = function () {
  console.log('main.js-onpageshow', window.location.pathname)
  var u = navigator.userAgent
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  const environment = environmentJudge()
  const hasFilePages = [
    '/applyDetail',
    '/approveDetails',
    '/informDetail',
    '/apply3',
    '/applyCover',
    '/archive',
    '/pdfPreview'
  ]
  if (
    [DINGTALK, QYWX].includes(environment) &&
    isiOS &&
    hasFilePages.includes(window.location.pathname)
  ) {
    // document.documentElement.style.width = "414px";
    document.documentElement.style.fontSize = originFontSize
    localStorage.setItem('DingFilePreview', 'true')
    console.log('原始fontsize', originFontSize)
  }
}
